import { Play } from "lucide-react";

interface VideoCardProps {
    title: string;
    description?: string;
    youtubeId: string;
    onClick?: (youtubeId: string) => void;
}

const VideoCard = ({ title, description, youtubeId, onClick }: VideoCardProps) => {
    const thumbnailUrl = `https://img.youtube.com/vi/${youtubeId}/hqdefault.jpg`;
    const titleId = `video-title-${youtubeId}`;
    const descriptionId = description ? `video-description-${youtubeId}` : undefined;

    return (
        <button
            type="button"
            onClick={() => onClick?.(youtubeId)}
            className="group relative block w-full rounded-lg overflow-hidden aspect-video bg-center bg-cover focus:outline-none"
            style={{ backgroundImage: `url(${thumbnailUrl})` }}
            aria-labelledby={titleId}
            aria-describedby={descriptionId}
            aria-label={`Play video: ${title}`}
        >
            <img
                src={thumbnailUrl}
                alt={title}
                loading="lazy"
                className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-black/20 group-hover:bg-black/40 group-focus:bg-black/40 transition-colors" />
            <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 group-focus:opacity-100 transition-opacity">
                <Play className="w-16 h-16 text-white drop-shadow" />
            </div>
            <div className="absolute inset-x-0 bottom-0 p-4 text-white bg-gradient-to-t from-black/70 via-black/20 to-transparent">
                <h3 id={titleId} className="text-lg font-semibold">
                    {title}
                </h3>
                {description && (
                    <p id={descriptionId} className="text-sm opacity-90">
                        {description}
                    </p>
                )}
            </div>
        </button>
    );
};

export default VideoCard;

